/** Unidade escolhida no menu lateral (filtra a Visão do sócio e os Indicadores). Lembrada no navegador. */
import { create } from "zustand";

const KEY = "vg:unidade";
const initial = (() => { try { return localStorage.getItem(KEY) ?? ""; } catch { return ""; } })();

export const useUnitStore = create<{ unitId: string; set: (id: string) => void }>((set) => ({
  unitId: initial,
  set: (id) => { try { localStorage.setItem(KEY, id); } catch { /* sem armazenamento */ } set({ unitId: id }); },
}));

export function useCurrentUnit(): string { return useUnitStore((s) => s.unitId); }
